import { isEmpty } from 'lodash-es';

export function isObject(maybeObj: unknown) {
  return typeof maybeObj === 'object' && !Array.isArray(maybeObj) && maybeObj !== null;
}

export function isEmptyOrEmptyObject(obj: unknown) {
  if (!isObject(obj)) {
    return isEmpty(obj);
  }

  return Object.keys(obj as object).length === 0;
}
